import { publicAsset } from "@/lib/publicAsset";

export default publicAsset("/zrs-logo.png");
